(function (app) {

    app.filter('sumColumn', function () {
        return function (data, key) {
          
            if (typeof (data) === 'undefined' || typeof (key) === 'undefined') {
                return 0;
            }

            var sum = 0;
            for (var i = data.length - 1; i >= 0; i--) {
               
                if (!isNaN(parseInt(data[i][key])))
                    sum += data[i][key];
            }
          
            return sum;
        };
    });

    app.filter('sumColumnAverage', function () {
        return function (data, key) {

            if (typeof (data) === 'undefined' || typeof (key) === 'undefined') {
                return 0;
            }

            var sum = 0;
            for (var i = data.length - 1; i >= 0; i--) {
                if (!isNaN(parseInt(data[i][key])))
                    sum += data[i][key];
            }

            return sum / data.length;
        };
    });
})(window.app);